import {
  ArrowUUpLeftIcon,
  CoffeeIcon,
  FloppyDiskIcon,
  PencilSimpleIcon,
  RobotIcon,
  TargetIcon,
} from '@phosphor-icons/react';
import { AddressBookIcon } from '@phosphor-icons/react/dist/csr/AddressBook';
import { AmbulanceIcon } from '@phosphor-icons/react/dist/csr/Ambulance';
import { ArchiveIcon } from '@phosphor-icons/react/dist/csr/Archive';
import { ArrowLeftIcon } from '@phosphor-icons/react/dist/csr/ArrowLeft';
import { ArrowLineLeftIcon } from '@phosphor-icons/react/dist/csr/ArrowLineLeft';
import { ArrowLineRightIcon } from '@phosphor-icons/react/dist/csr/ArrowLineRight';
import { ArrowRightIcon } from '@phosphor-icons/react/dist/csr/ArrowRight';
import { ArrowsClockwiseIcon } from '@phosphor-icons/react/dist/csr/ArrowsClockwise';
import { ArrowsCounterClockwiseIcon } from '@phosphor-icons/react/dist/csr/ArrowsCounterClockwise';
import { ArrowsInSimpleIcon } from '@phosphor-icons/react/dist/csr/ArrowsInSimple';
import { ArrowsLeftRightIcon } from '@phosphor-icons/react/dist/csr/ArrowsLeftRight';
import { ArrowSquareOutIcon } from '@phosphor-icons/react/dist/csr/ArrowSquareOut';
import { AsclepiusIcon } from '@phosphor-icons/react/dist/csr/Asclepius';
import { BandaidsIcon } from '@phosphor-icons/react/dist/csr/Bandaids';
import { BellRingingIcon } from '@phosphor-icons/react/dist/csr/BellRinging';
import { BellSlashIcon } from '@phosphor-icons/react/dist/csr/BellSlash';
import { BuildingOfficeIcon } from '@phosphor-icons/react/dist/csr/BuildingOffice';
import { CalendarIcon } from '@phosphor-icons/react/dist/csr/Calendar';
import { CalendarDotsIcon } from '@phosphor-icons/react/dist/csr/CalendarDots';
import { CalendarXIcon } from '@phosphor-icons/react/dist/csr/CalendarX';
import { CaretDownIcon } from '@phosphor-icons/react/dist/csr/CaretDown';
import { CaretLeftIcon } from '@phosphor-icons/react/dist/csr/CaretLeft';
import { CaretRightIcon } from '@phosphor-icons/react/dist/csr/CaretRight';
import { CaretUpIcon } from '@phosphor-icons/react/dist/csr/CaretUp';
import { ChatDotsIcon } from '@phosphor-icons/react/dist/csr/ChatDots';
import { ChatsIcon } from '@phosphor-icons/react/dist/csr/Chats';
import { ChatTextIcon } from '@phosphor-icons/react/dist/csr/ChatText';
import { CheckIcon } from '@phosphor-icons/react/dist/csr/Check';
import { CheckCircleIcon } from '@phosphor-icons/react/dist/csr/CheckCircle';
import { CheckFatIcon } from '@phosphor-icons/react/dist/csr/CheckFat';
import { ClipboardTextIcon } from '@phosphor-icons/react/dist/csr/ClipboardText';
import { ClockIcon } from '@phosphor-icons/react/dist/csr/Clock';
import { ConfettiIcon } from '@phosphor-icons/react/dist/csr/Confetti';
import { CopyIcon } from '@phosphor-icons/react/dist/csr/Copy';
import { DeviceMobileIcon } from '@phosphor-icons/react/dist/csr/DeviceMobile';
import { DotsSixVerticalIcon } from '@phosphor-icons/react/dist/csr/DotsSixVertical';
import { DotsThreeVerticalIcon } from '@phosphor-icons/react/dist/csr/DotsThreeVertical';
import { DropSlashIcon } from '@phosphor-icons/react/dist/csr/DropSlash';
import { EnvelopeIcon } from '@phosphor-icons/react/dist/csr/Envelope';
import { FirstAidIcon } from '@phosphor-icons/react/dist/csr/FirstAid';
import { FirstAidKitIcon } from '@phosphor-icons/react/dist/csr/FirstAidKit';
import { GearIcon } from '@phosphor-icons/react/dist/csr/Gear';
import { HandHeartIcon } from '@phosphor-icons/react/dist/csr/HandHeart';
import { HospitalIcon } from '@phosphor-icons/react/dist/csr/Hospital';
import { HouseIcon } from '@phosphor-icons/react/dist/csr/House';
import { HouseLineIcon } from '@phosphor-icons/react/dist/csr/HouseLine';
import { InfoIcon } from '@phosphor-icons/react/dist/csr/Info';
import { LayoutIcon } from '@phosphor-icons/react/dist/csr/Layout';
import { ListIcon } from '@phosphor-icons/react/dist/csr/List';
import { ListMagnifyingGlassIcon } from '@phosphor-icons/react/dist/csr/ListMagnifyingGlass';
import { MagnifyingGlassIcon } from '@phosphor-icons/react/dist/csr/MagnifyingGlass';
import { NoteIcon } from '@phosphor-icons/react/dist/csr/Note';
import { PaletteIcon } from '@phosphor-icons/react/dist/csr/Palette';
import { PaperPlaneTiltIcon } from '@phosphor-icons/react/dist/csr/PaperPlaneTilt';
import { PauseIcon } from '@phosphor-icons/react/dist/csr/Pause';
import { PhoneIcon } from '@phosphor-icons/react/dist/csr/Phone';
import { PhoneCallIcon } from '@phosphor-icons/react/dist/csr/PhoneCall';
import { PhoneDisconnectIcon } from '@phosphor-icons/react/dist/csr/PhoneDisconnect';
import { PhoneIncomingIcon } from '@phosphor-icons/react/dist/csr/PhoneIncoming';
import { PhoneOutgoingIcon } from '@phosphor-icons/react/dist/csr/PhoneOutgoing';
import { PhonePauseIcon } from '@phosphor-icons/react/dist/csr/PhonePause';
import { PhonePlusIcon } from '@phosphor-icons/react/dist/csr/PhonePlus';
import { PhoneTransferIcon } from '@phosphor-icons/react/dist/csr/PhoneTransfer';
import { PhoneXIcon } from '@phosphor-icons/react/dist/csr/PhoneX';
import { PlusIcon } from '@phosphor-icons/react/dist/csr/Plus';
import { ProhibitIcon } from '@phosphor-icons/react/dist/csr/Prohibit';
import { QuestionIcon } from '@phosphor-icons/react/dist/csr/Question';
import { SealCheckIcon } from '@phosphor-icons/react/dist/csr/SealCheck';
import { ShieldPlusIcon } from '@phosphor-icons/react/dist/csr/ShieldPlus';
import { ShootingStarIcon } from '@phosphor-icons/react/dist/csr/ShootingStar';
import { SignOutIcon } from '@phosphor-icons/react/dist/csr/SignOut';
import { SmileyMeltingIcon } from '@phosphor-icons/react/dist/csr/SmileyMelting';
import { SparkleIcon } from '@phosphor-icons/react/dist/csr/Sparkle';
import { StarIcon } from '@phosphor-icons/react/dist/csr/Star';
import { StethoscopeIcon } from '@phosphor-icons/react/dist/csr/Stethoscope';
import { SwapIcon } from '@phosphor-icons/react/dist/csr/Swap';
import { ThumbsDownIcon } from '@phosphor-icons/react/dist/csr/ThumbsDown';
import { ThumbsUpIcon } from '@phosphor-icons/react/dist/csr/ThumbsUp';
import { TrashIcon } from '@phosphor-icons/react/dist/csr/Trash';
import { UserIcon } from '@phosphor-icons/react/dist/csr/User';
import { UserCircleDashedIcon } from '@phosphor-icons/react/dist/csr/UserCircleDashed';
import { UserCircleMinusIcon } from '@phosphor-icons/react/dist/csr/UserCircleMinus';
import { UserCirclePlusIcon } from '@phosphor-icons/react/dist/csr/UserCirclePlus';
import { UserListIcon } from '@phosphor-icons/react/dist/csr/UserList';
import { UserPlusIcon } from '@phosphor-icons/react/dist/csr/UserPlus';
import { UsersIcon } from '@phosphor-icons/react/dist/csr/Users';
import { UserSquareIcon } from '@phosphor-icons/react/dist/csr/UserSquare';
import { UsersThreeIcon } from '@phosphor-icons/react/dist/csr/UsersThree';
import { VideoCameraIcon } from '@phosphor-icons/react/dist/csr/VideoCamera';
import { WarningIcon } from '@phosphor-icons/react/dist/csr/Warning';
import { WarningCircleIcon } from '@phosphor-icons/react/dist/csr/WarningCircle';
import { WrenchIcon } from '@phosphor-icons/react/dist/csr/Wrench';
import { XIcon } from '@phosphor-icons/react/dist/csr/X';
import { XCircleIcon } from '@phosphor-icons/react/dist/csr/XCircle';

export const ICON_MAP: Record<string, React.ElementType> = {
  AddressBook: AddressBookIcon,
  Asclepius: AsclepiusIcon,
  Ambulance: AmbulanceIcon,
  ArrowLeft: ArrowLeftIcon,
  ArrowLineLeft: ArrowLineLeftIcon,
  ArrowLineRight: ArrowLineRightIcon,
  ArrowRight: ArrowRightIcon,
  ArrowsClockwise: ArrowsClockwiseIcon,
  ArrowsCounterClockwise: ArrowsCounterClockwiseIcon,
  ArrowsLeftRight: ArrowsLeftRightIcon,
  ArrowsInSimple: ArrowsInSimpleIcon,
  ArrowSquareOut: ArrowSquareOutIcon,
  ArrowUUpLeftIcon: ArrowUUpLeftIcon,
  Archive: ArchiveIcon,
  BandAids: BandaidsIcon,
  BellRinging: BellRingingIcon,
  BellSlash: BellSlashIcon,
  BuildingOffice: BuildingOfficeIcon,
  Calendar: CalendarIcon,
  CalendarDots: CalendarDotsIcon,
  CalendarX: CalendarXIcon,
  CaretDown: CaretDownIcon,
  CaretLeft: CaretLeftIcon,
  CaretRight: CaretRightIcon,
  CaretUp: CaretUpIcon,
  ChatDots: ChatDotsIcon,
  Chats: ChatsIcon,
  ChatText: ChatTextIcon,
  Check: CheckIcon,
  CheckCircle: CheckCircleIcon,
  CheckFat: CheckFatIcon,
  ClipboardText: ClipboardTextIcon,
  Clock: ClockIcon,
  Coffee: CoffeeIcon,
  Confetti: ConfettiIcon,
  Copy: CopyIcon,
  DeviceMobile: DeviceMobileIcon,
  DotsThreeVertical: DotsThreeVerticalIcon,
  DotsSixVertical: DotsSixVerticalIcon,
  DropSlash: DropSlashIcon,
  Envelope: EnvelopeIcon,
  FirstAid: FirstAidIcon,
  FirstAidKit: FirstAidKitIcon,
  Save: FloppyDiskIcon,
  Gear: GearIcon,
  HandHeart: HandHeartIcon,
  Hospital: HospitalIcon,
  House: HouseIcon,
  HouseLine: HouseLineIcon,
  Info: InfoIcon,
  Layout: LayoutIcon,
  List: ListIcon,
  ListMagnifyingGlass: ListMagnifyingGlassIcon,
  MagnifyingGlass: MagnifyingGlassIcon,
  Note: NoteIcon,
  PaperPlaneTilt: PaperPlaneTiltIcon,
  Palette: PaletteIcon,
  Pause: PauseIcon,
  PencilSimple: PencilSimpleIcon,
  Phone: PhoneIcon,
  PhoneCall: PhoneCallIcon,
  PhoneIncoming: PhoneIncomingIcon,
  PhoneOutgoing: PhoneOutgoingIcon,
  PhoneEnded: PhoneDisconnectIcon,
  PhonePause: PhonePauseIcon,
  PhonePlus: PhonePlusIcon,
  PhoneTransfer: PhoneTransferIcon,
  PhoneX: PhoneXIcon,
  Plus: PlusIcon,
  Prohibit: ProhibitIcon,
  Question: QuestionIcon,
  Robot: RobotIcon,
  SealCheck: SealCheckIcon,
  ShieldPlus: ShieldPlusIcon,
  ShootingStar: ShootingStarIcon,
  SignOut: SignOutIcon,
  Stethoscope: StethoscopeIcon,
  SmileyMelting: SmileyMeltingIcon,
  Sparkle: SparkleIcon,
  Star: StarIcon,
  Swap: SwapIcon,
  Target: TargetIcon,
  ThumbsDown: ThumbsDownIcon,
  ThumbsUp: ThumbsUpIcon,
  Trash: TrashIcon,
  User: UserIcon,
  UserCircleDashed: UserCircleDashedIcon,
  UserCircleMinus: UserCircleMinusIcon,
  UserCirclePlus: UserCirclePlusIcon,
  UserList: UserListIcon,
  UserPlus: UserPlusIcon,
  Users: UsersIcon,
  UserSquare: UserSquareIcon,
  UsersThree: UsersThreeIcon,
  VideoCamera: VideoCameraIcon,
  Warning: WarningIcon,
  WarningCircle: WarningCircleIcon,
  Wrench: WrenchIcon,
  XCircle: XCircleIcon,
  X: XIcon,
};

export const ICON_NAME_OPTIONS = Object.keys(ICON_MAP);
